module.exports = __webpack_public_path__ + "static/media/diarrhoea.45ed8bc7.png";